package one.devsbox.www.ui.users.edit

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import kotlinx.coroutines.CoroutineScope
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.tools.EFieldTextValue
import one.devsbox.www.tools.PermissionWrapperEditor
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class UserECtx private constructor(
    val vm: UserEVM,
    val nav: Navigation,
    val args: ArgsId,
    val myPermissions: SharedIO.Permission.PermissionWrapper,
    val editingMyAccount: Boolean,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): UserECtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args<ArgsId>()
            val vm = nav.viewModel(UserEVM::class)
            val me = LocalMeProvider.current
            val colorPrimary = MaterialTheme.colorScheme.primary
            val colorSecondary = MaterialTheme.colorScheme.secondary
            return remember(args.id) {
                UserECtx(
                    vm = vm,
                    nav = nav,
                    args = args,
                    myPermissions = me.permission,
                    editingMyAccount = me.info.id == args.id,
                    colorPrimaryContainer = colorPrimary,
                    colorSecondaryContainer = colorSecondary
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }

    class Editor(
        @Suppress("unused") val scope: CoroutineScope,
        val user: SharedIO.User
    ) {
        val name = EFieldTextValue(
            property = user::name,
            condition = { it.trim().takeIf { it.isNotEmpty() } }
        )

        val login = EFieldTextValue(
            property = user::login,
            condition = { it.trim().takeIf { it.isNotEmpty() } }
        )

        val permissions = PermissionWrapperEditor(user.permission)
    }
}
